import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { LogOut } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LogoutConfirmModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function LogoutConfirmModal({ open, onOpenChange, onConfirm }: LogoutConfirmModalProps) {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        {/* Overlay - clique fora fecha o modal */}
        <AlertDialog.Overlay
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 cursor-pointer"
          onClick={() => onOpenChange(false)}
        />

        {/* Content */}
        <AlertDialog.Content
          className={cn(
            'fixed left-[50%] top-[50%] z-50 w-full max-w-sm translate-x-[-50%] translate-y-[-50%]',
            'rounded-2xl border border-border/50 bg-card/95 backdrop-blur-xl p-8 shadow-2xl',
            'data-[state=open]:animate-in data-[state=closed]:animate-out',
            'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
            'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
            'data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]',
            'data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]',
            'duration-200',
          )}
        >
          <div className="flex flex-col items-center text-center">
            {/* Icon */}
            <div className="relative mb-6">
              <div className="absolute inset-0 rounded-full bg-destructive/20 blur-xl" />
              <div className="relative flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 border border-destructive/20">
                <LogOut className="h-6 w-6 text-destructive" />
              </div>
            </div>

            {/* Title */}
            <AlertDialog.Title className="text-xl font-semibold text-foreground tracking-tight">
              Sair da conta
            </AlertDialog.Title>

            {/* Description */}
            <AlertDialog.Description className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-[260px]">
              Você precisará fazer login novamente para acessar o zonisigma.app
            </AlertDialog.Description>
          </div>

          {/* Actions */}
          <div className="mt-8 flex gap-3">
            <AlertDialog.Cancel
              className={cn(
                'flex-1 inline-flex items-center justify-center rounded-xl px-4 py-3',
                'text-sm font-medium transition-all duration-200 outline-none',
                'bg-muted/50 text-muted-foreground',
                'hover:bg-muted hover:text-foreground',
                'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
              )}
            >
              Cancelar
            </AlertDialog.Cancel>

            <AlertDialog.Action
              onClick={onConfirm}
              className={cn(
                'group flex-1 inline-flex items-center justify-center gap-2 rounded-xl px-4 py-3',
                'text-sm font-medium transition-all duration-200 outline-none',
                'bg-destructive text-white',
                'hover:bg-destructive/90',
                'focus-visible:ring-2 focus-visible:ring-destructive focus-visible:ring-offset-2 focus-visible:ring-offset-background',
              )}
            >
              <LogOut className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
              <span>Sair</span>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
